import css from './Desktop.module.scss'
import React, { PropsWithChildren } from 'react'

import WithAppInitialized from 'components/common/WithAppInitialized'
import { useI18NContext } from 'components/HOC/WithTranslation'

import Voice, { VoiceSkeleton } from '../Voice'

interface IProps {
  voices: string[]
  activeSection: string
  setActiveMenuVoiceCallback(voice: string): void
}

const Desktop: React.FC<PropsWithChildren<IProps>> = (props) => {
  const { voices, activeSection, setActiveMenuVoiceCallback, children } = props

  const { namespacesLoaded } = useI18NContext()

  return (
    <div className={css.pagewithsubsections_voices_desktop_container}>
      {voices.map((elem, key) => {
        return (
          <WithAppInitialized showChildren={namespacesLoaded} skeleton={<VoiceSkeleton />}>
            <Voice
              key={key}
              name={elem}
              isActive={elem === activeSection}
              setActiveMenuVoiceCallback={setActiveMenuVoiceCallback}
            />
          </WithAppInitialized>
        )
      })}

      {children}

      <div className={css.spacing_bottom}></div>
    </div>
  )
}

export default Desktop
